const color_scheme = require("../../color_scheme.json");

export function create_sets(assets, datapoint_name) {
	let sets = {};
	for (let asset of assets) {
		sets[asset] = {
			'color': color_scheme[asset]['color'],
			'hover_color': color_scheme[asset]['hover_color'],
			'name': asset + "_" + datapoint_name,
			'data': []
		}
	}
	return sets;
}
